import React, { useEffect, ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { ModalOverlay, ModalContent } from './ModalComponents';

interface ModalProps {
  children: ReactNode;
  isOpen: boolean;
  onClose: () => void;
  maxWidth?: string;
  noPadding?: boolean;
  zIndex?: number;
  preventScroll?: boolean;
  centered?: boolean;
}

const Modal: React.FC<ModalProps> = ({
  children,
  isOpen,
  onClose,
  maxWidth,
  zIndex,
  preventScroll = true
}) => {
  useEffect(() => {
    if (preventScroll && isOpen) {
      document.body.classList.add('modal-open');
      document.body.style.overflow = 'hidden';

      return () => {
        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
      };
    }
  }, [isOpen, preventScroll]);

  if (!isOpen) return null;

  const modalElement = (
    <ModalOverlay zIndex={zIndex} onClick={onClose}>
      <ModalContent maxWidth={maxWidth} onClick={(e) => e.stopPropagation()}>
        {children}
      </ModalContent>
    </ModalOverlay>
  );

  return createPortal(modalElement, document.body);
};

export default Modal;
